// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1EJZE","addWidgetButton":"Header_addWidgetButton__FTR_q","dashboardTabs":"Header_dashboardTabs__36Jxn","active":"Header_active__1p9iG"};